import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var NoService = React.createClass({

  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  updateContactInfo(event) {
    if(event.type == 'click') {
      return;
    }
    AvailabilityActions.updateContactInfo(event.target.name, event.target.value);
  },

  submitContactMe(event) {
  	AvailabilityActions.submitResContactMe(this.state.store.toJS());
      event.preventDefault();
      event.stopPropagation();
      return false;
  },
  getContactInfoErrors() {
  	AvailabilityActions.validateContactInfo(this.state.store.toJS());
  },


  render() {
      const { t } = this.props;
      var store = this.state.store;

  	var first_name_error, last_name_error, email_error, phone_error, is_valid;

    if(store.get('errors').size && store.getIn(['errors', 'contact_info']).size) {
      is_valid = store.getIn(['contact_info', 'is_valid']);
      first_name_error = store.getIn(['errors', 'contact_info', 'first_name']);
      last_name_error = store.getIn(['errors', 'contact_info', 'last_name']);
      email_error = store.getIn(['errors', 'contact_info', 'email_address']);
      phone_error = store.getIn(['errors', 'contact_info', 'phone_number']);
    }
    else {
      is_valid = false;
    }

    let res_optional = " (Optional)";
    if (store.getIn(['input_address', 'serviceType']).indexOf('business') >= 0) {
        res_optional = "";
    }

    var address;
    if(store.get('postal_address').size) {
      address = store.get('postal_address').toJS();
    }
    else if(store.get('qualified_address').size) {
      address = store.get('qualified_address').toJS();
    }
    else {
      address = {
        address: store.getIn(['input_address', 'streetAddress']),
        unit: store.getIn(['input_address', 'secondary']),
        city: store.getIn(['input_address', 'city']),
        human_city: store.getIn(['input_address', 'human_city']),
        state: store.getIn(['input_address', 'state']),
        zip: store.getIn(['input_address', 'zip'])
      };
    }
    var unit = (address.unit) ? address.unit : address.LocationValue1;
    unit = (unit) ? ' ' + unit : '';
    var human_city = (address.human_city) ? address.human_city : address.city;
    var prequal_key;
    if(store.get('sso_user')) {
      prequal_key = <div>Prequal Key: {store.get('async_id')}</div>
    }

  	return (
			<form onSubmit={this.submitContactMe}>
				<div className="text-center" >
					<h2>{t('common:no_service_header')}</h2>
				</div>
				<p className="lead">{t('common:no_service_p1')}</p>
				<p className="lead">{t('common:no_service_p2')}</p>
        {prequal_key}

        <p>
        <a href="" className="btn btn-lg btn-primary">{t('common:try_again_button')}</a>
        </p>

				<h3>{t('common:no_service_updates_header')}</h3>
				<p className="lead">
					{t('common:no_service_updates_text')}
            		<span className="text-nowrap address-only"> {address.address}{unit}, {human_city} {address.state} {address.zip}</span>
            	</p>

          <div className={"col-sm-12 form-group"+(email_error ? " has-error" : "")}>
            <label htmlFor="email_address">{t('common:email_address_label')}</label>
            <input type="text" name="email_address" value={store.getIn(['contact_info', 'email_address']) || ''} onInput={this.updateContactInfo} onBlur={this.getContactInfoErrors} className="form-control" id="email_address" placeholder={t('common:email_address_placeholder')} />
            <p className="help-block">{email_error ? t('common:email_error') : ''}</p>
          </div>

          <div className={"col-sm-12 form-group"+(first_name_error ? " has-error" : "")}>
            <label htmlFor="first_name">{t('common:first_name_label')}</label>
            <input type="text" name="first_name" value={store.getIn(['contact_info', 'first_name']) || ''} onInput={this.updateContactInfo} onBlur={this.getContactInfoErrors} className="form-control" id="first_name" placeholder={t('common:first_name_placeholder')} />
            <p className="help-block">{first_name_error ? t('common:first_name_error') : ''}</p>
          </div>

          <div className={"col-sm-12 form-group"+(last_name_error ? " has-error" : "")}>
            <label htmlFor="last_name">{t('common:last_name_label')}{res_optional}</label>
            <input type="text" name="last_name" value={store.getIn(['contact_info', 'last_name']) || ''} onInput={this.updateContactInfo} onBlur={this.getContactInfoErrors} className="form-control" id="last_name" placeholder={t('common:last_name_placeholder')} />
            <p className="help-block">{last_name_error ? t('common:last_name_error') : ''}</p>
          </div>

          <div className="col-sm-12 form-group">
            <label htmlFor="company_name">{t('common:company_name_label')}{res_optional}</label>
            <input type="text" name="company_name" value={store.getIn(['contact_info', 'company_name']) || ''} onInput={this.updateContactInfo} className="form-control" id="company_name" placeholder={t('common:company_name_placeholder')} />
            <p className="help-block"></p>
          </div>

          <div className={"col-sm-12 form-group"+(phone_error ? " has-error" : "")}>
            <label htmlFor="phone_number">{t('common:phone_number_label')}</label>
            <input type="text" name="phone_number" value={store.getIn(['contact_info', 'phone_number']) || ''} onInput={this.updateContactInfo} onBlur={this.getContactInfoErrors} className="form-control" id="phone" placeholder={t('common:phone_number_placeholder')} />
            <p className="help-block">{phone_error ? t('common:phone_error') : ''}</p>
        </div>
				<div >
					<button type="submit" className={"btn btn-lg btn-primary"+(is_valid ? "" : " disabled")}>{t('common:keep_me_updated')}</button>
				</div>
			</form>
  	)
  }
});

export default  translate('common', { wait: true })(NoService);